import RouteLoading from '@/components/RouteLoading.vue'

/**
 * 布局内页面懒加载：立即展示轻量占位，真实页面 chunk 在后台解析。
 * 避免大页面 JS 解析长时间占主线程时，侧栏再次点击像「无响应」。
 */
export function lazyLayoutView(importFn) {
  return () => ({
    component: importFn(),
    loading: RouteLoading,
    /** 极快命中缓存时不闪占位；慢于 120ms 再展示骨架 */
    delay: 120,
    timeout: 120000
  })
}
